module.exports = __webpack_public_path__ + "static/img/handcuffs.4026629.png";